/* global toastr */
import React from 'react'
import Swal from 'sweetalert2'
import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'
import { Link } from 'react-router-dom'
import { Panel } from '../smart_bps/lib/components'
import AccessObjectTooltip from './AccessObjectTooltip'
import { initSelect2InModal, destroySelect2InModal } from '../lib/select2Modal'
import { Tooltip } from '../smart_bps/lib/components'

class ModelView extends SigurModelView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      accessObjects: [],
      document_dates: [],
      showAccessObjectsModal: false,
      modalAccessObjects: [],
      modalPage: 1,
      modalTotalPages: 1,
      modalSelectedIds: new Set(),
      modalExcludedIds: new Set(),
      isModalSelectedAll: false,
      showBlacklistHistoryForAoId: null,
      blacklistHistoryItems: [],
      modalFilters: {
        name: '',
        position: '',
        department: '',
        object_type: '',
      },
      filterOptions: {
        positions: [],
        departments: [],
        object_types: [],
      },
    }

    this.docsTabRef = React.createRef()
    this.openAccessObjectsModal = this.openAccessObjectsModal.bind(this)
    this.openBlacklistHistoryForAo = this.openBlacklistHistoryForAo.bind(this)
    this.closeBlacklistHistoryForAo = this.closeBlacklistHistoryForAo.bind(this)
    this.closeAccessObjectsModal = this.closeAccessObjectsModal.bind(this)
    this.handleModalSearch = this.handleModalSearch.bind(this)
    this.handleSelectAllFound = this.handleSelectAllFound.bind(this)
    this.handleToggleAccessObject = this.handleToggleAccessObject.bind(this)
    this.handleApplyAccessObjects = this.handleApplyAccessObjects.bind(this)
    this.handleRemoveAccessObject = this.handleRemoveAccessObject.bind(this)
    this.loadAccessObjects = this.loadAccessObjects.bind(this)
    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
    this.accessObjectsModalRef = React.createRef()
    this.loadDocumentDates = this.loadDocumentDates.bind(this)
    this.onDocumentDateSaved = this.onDocumentDateSaved.bind(this)
    this.onFileDeleted = this.onFileDeleted.bind(this)
  }

  loadDocumentDates() {
    const objectId = this.object_id
    if (!objectId || objectId === 0) return
    request({
      method: 'get',
      url: `/api/${PROJECT_NAME}/${objectId}/document_dates`,
      success: (data) => {
        this.setState({ document_dates: data.items || [] })
      },
    })
  }

  closeBlacklistHistoryForAo() {
    this.setState({ showBlacklistHistoryForAoId: null })
  }

  onDocumentDateSaved(item) {
    this.setState((s) => {
      const existing = s.document_dates || []
      const idx = existing.findIndex((d) => d.doc_type_id === item.doc_type_id)
      if (idx >= 0) {
        const next = [...existing]
        next[idx] = item
        return { document_dates: next }
      }
      return { document_dates: [...existing, item] }
    })
  }

  onFileDeleted(fileId) {
    this.setState((s) => ({
      files: (s.files || []).filter((f) => f.id !== fileId),
    }))
  }

  // Проверка прав из state.perms
  hasPerm(perm) {
    return this.state.perms && this.state.perms.includes(perm)
  }

  getDeleteConfirmTitle() {
    return 'Удаление группы доступа'
  }

  showTooltip(e, ao) {
    this.setState({
      tooltipData: ao,
      tooltipPosition: {
        top: e.clientY + 15,
        left: e.clientX - 100,
      },
    })
  }

  hideTooltip() {
    this.setState({ tooltipData: null })
  }

  componentDidMount() {
    super.componentDidMount && super.componentDidMount()
    this.loadAccessObjects()
  }

  loadAccessObjects() {
    const objectId = this.object_id
    if (!objectId || objectId === 0) return

    request({
      method: 'get',
      url: `/api/object_groups/${objectId}/access_objects`,
      success: (data) => {
        this.setState({ accessObjects: data.items || [] })
      },
      error: (data) => {
        console.error('Error loading access objects:', data)
      },
    })
  }


  loadModalAccessObjects(page = 1) {
    const objectId = this.object_id || 0
    const { modalFilters } = this.state

    request({
      method: 'post',
      url: `/api/object_groups/${objectId}/access_objects/list`,
      data: {
        page: page,
        page_size: 15,
        filters: modalFilters,
      },
      success: (data) => {
        this.setState({
          modalAccessObjects: data.items || [],
          modalPage: data.page || 1,
          modalTotalPages: data.total_pages || 1,
        })
      },
      error: (data) => {
        console.error('Error loading modal access objects:', data)
      },
    })
  }

  openAccessObjectsModal() {
    this.setState(
      {
        showAccessObjectsModal: true,
        modalSelectedIds: new Set(),
        modalFilters: { name: '', position: '', department: '', object_type: '' },
      },
      () => {
        this.loadModalAccessObjects(1)
        setTimeout(() => {
          initSelect2InModal(this.accessObjectsModalRef.current, (name, val) => {
            this.setState((prev) => ({
              modalFilters: { ...prev.modalFilters, [name]: val },
            }))
          })
        }, 0)
      }
    )
  }

  closeAccessObjectsModal() {
    destroySelect2InModal(this.accessObjectsModalRef.current)
    this.setState({ showAccessObjectsModal: false, isModalSelectedAll: false })
  }

  handleModalSearch() {
    this.loadModalAccessObjects(1)
    this.setState({ isModalSelectedAll: false })
  }

  handleSelectAllFound(isCancelSelected) {
    this.setState({isModalSelectedAll: !isCancelSelected, modalExcludedIds: new Set(), modalSelectedIds: new Set()})
  }

  handleToggleAccessObject(aoId, isAlreadyAdded) {
    const { modalSelectedIds, modalExcludedIds, isModalSelectedAll } = this.state
    const newSelectedIds = isModalSelectedAll ? new Set(modalExcludedIds) : new Set(modalSelectedIds)

    if (newSelectedIds.has(aoId)) {
      newSelectedIds.delete(aoId)
    } else if (!isAlreadyAdded) {
      newSelectedIds.add(aoId)
    }

    this.setState({
      [isModalSelectedAll ? 'modalExcludedIds' : 'modalSelectedIds']: newSelectedIds,
    })

    if (isAlreadyAdded) {
      this.handleRemoveAccessObject(aoId, true)
      this.setState(prevState => ({
        modalAccessObjects: prevState.modalAccessObjects.map(item =>
          item.id === aoId ? { ...item, already_added: false } : item
        )
      }));
    }
  }

  handleApplyAccessObjects() {
    const { modalSelectedIds, modalExcludedIds, isModalSelectedAll, modalFilters } = this.state
    const objectId = this.object_id

    if (modalSelectedIds.size === 0 && !isModalSelectedAll) {
      this.closeAccessObjectsModal()
      return
    }

    if (!objectId || objectId === 0) {
      toastr.warning('Сначала сохраните карточку группы')
      return
    }

    request({
      method: 'post',
      url: `/api/object_groups/${objectId}/access_objects/add`,
      data: {
        is_selected_all: isModalSelectedAll,
        access_object_ids: Array.from(isModalSelectedAll ? modalExcludedIds : modalSelectedIds),
        filters: modalFilters,
      },
      success: () => {
        toastr.success('Посетители добавлены')
        this.closeAccessObjectsModal()
        this.loadAccessObjects()
      },
      error: (data) => {
        toastr.error(data.detail || 'Ошибка при добавлении посетителей')
      },
    })
  }

  handleRemoveAccessObject(aoId, isFromModal) {
    const objectId = this.object_id
    const requestData = {
      method: 'post',
      url: `/api/object_groups/${objectId}/access_objects/remove`,
      data: {
        access_object_id: aoId,
      },
      success: () => {
        if (!isFromModal) toastr.success('Посетитель удален')
        this.loadAccessObjects()
      },
      error: (data) => {
        toastr.error(data.detail || 'Ошибка при удалении посетителя')
      },
    }

    if (isFromModal) {
      request(requestData)
    } else {
      Swal.fire({
        title: 'Удалить посетителя?',
        text: 'Посетитель будет удален из заявки',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        focusConfirm: false,
        focusCancel: false,
        customClass: {
          confirmButton: 'btn btn-outline-primary',
          cancelButton: 'btn btn-outline-secondary',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          request(requestData)
        }
      })
    }
  }

  // Панель информации справа (скрываем общий блок «Файлы»; он не должен быть в группах)
  renderContentRight() {
    const blocks = []

    if (this.object_id === 0) {
      return blocks
    }

    const filesSchema = this.state.files_schema || []

    if (filesSchema.length > 0) {
      blocks.push(
        <div key="files" className="mb-3">
          {this.renderFileBlock(true)}
        </div>
      )
    }
    blocks.push(this.renderComments())
    return blocks
  }

  // Скрываем кнопку "Создать" в карточке
  renderTopPanelLeftItems() {
    return []
  }

  openBlacklistHistoryForAo(accessObjectId) {
    this.setState({ showBlacklistHistoryForAoId: accessObjectId, blacklistHistoryItems: null })
    const that = this
    request({
      method: 'get',
      url: `/api/access_objects/${accessObjectId}/blacklist_history`,
      success: (data) => {
        that.setState({ blacklistHistoryItems: data.items || [] })
      },
      error: () => {
        that.setState({ blacklistHistoryItems: [] })
        toastr.error('Не удалось загрузить историю')
      },
    })
  }

  renderBlacklistHistoryModalForOG() {
    if (!this.state.showBlacklistHistoryForAoId) return null
    const items = this.state.blacklistHistoryItems || []
    const formatDate = (iso) => {
      if (!iso) return '—'
      try {
        const d = new Date(iso)
        return d.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
      } catch (e) {
        return iso
      }
    }
    return (
      <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">История изменений (черный список)</h5>
              <button type="button" className="btn-close" onClick={this.closeBlacklistHistoryForAo} aria-label="Закрыть" />
            </div>
            <div className="modal-body">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>В черном списке</th>
                    <th>Дата события</th>
                    <th>Причина</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 && (
                    <tr><td colSpan={3} className="text-muted">Нет записей</td></tr>
                  )}
                  {items.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.in_blacklist_display || (row.in_blacklist ? 'Да' : 'Нет')}</td>
                      <td>{formatDate(row.d_event)}</td>
                      <td>{row.reason || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeBlacklistHistoryForAo}>Закрыть</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Таблица объектов доступа
  renderAccessObjectsTable() {
    const { accessObjects } = this.state
    const canAdd = this.hasPerm('add_access_objects')
    const canRemove = this.hasPerm('remove_access_objects')

    return (
      <Panel header="Посетители" key="access_objects_table">
        {canAdd && (
          <div className="mb-3">
            <button className="btn btn-primary btn-sm" onClick={this.openAccessObjectsModal}>
              Изменить состав группы
            </button>
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Должность</th>
                <th>Пройден мед. осмотр</th>
                <th>В черном списке</th>
                {canRemove && <th style={{ width: '50px' }}></th>}
              </tr>
            </thead>
            <tbody>
              {accessObjects.length === 0 ? (
                <tr>
                  <td
                    colSpan={canRemove ? 6 : 5}
                    className="text-center text-muted"
                  >
                    Нет связанных объектов доступа
                  </td>
                </tr>
              ) : (
                accessObjects.map((ao) => (
                  <tr key={ao.id} className={!ao.is_active ? 'table-warning' : ''}>
                    <td>
                      <Link className='pe-1' to={`/access_objects/${ao.access_object_id}/`} target="_blank">{ao.name}</Link>
                      {!ao.is_active && (
                        <Tooltip message='Недействующий' />
                      )}
                    </td>
                    <td>{ao.position}</td>
                    <td>{ao.medical_exam}</td>
                    <td>
                      {ao.blacklist ? (
                        <span
                          role="button"
                          tabIndex={0}
                          style={{ cursor: 'pointer', textDecoration: 'underline', color: '#ff5a00' }}
                          onClick={() => this.openBlacklistHistoryForAo(ao.access_object_id)}
                          onKeyDown={(e) => e.key === 'Enter' && this.openBlacklistHistoryForAo(ao.access_object_id)}
                        >
                          Да
                        </span>
                      ) : (
                        'Нет'
                      )}
                    </td>
                    {canRemove && (
                      <td>
                        <button
                          className="btn btn-outline-danger btn-xs"
                          onClick={() => this.handleRemoveAccessObject(ao.access_object_id)}
                          title="Удалить"
                        >
                          <i className="ti ti-trash"></i>
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {this.renderBlacklistHistoryModalForOG()}
      </Panel>
    )
  }

  // Модальное окно выбора объектов доступа
  renderAccessObjectsModal() {
    const {
      showAccessObjectsModal,
      modalAccessObjects,
      modalPage,
      modalTotalPages,
      modalSelectedIds,
      modalFilters,
      filterOptions,
      isModalSelectedAll,
      modalExcludedIds,
    } = this.state

    if (!showAccessObjectsModal) {
      return null
    }

    const isCancelSelected = (isModalSelectedAll && !Array.from(modalExcludedIds).length) || (Array.from(modalSelectedIds).length === Array.from(modalAccessObjects).length)

    return (
        <div
        ref={this.accessObjectsModalRef}
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="access_objects_modal"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Доступные посетители</h5>
              <button type="button" className="btn-close" onClick={this.closeAccessObjectsModal}></button>
            </div>
            <div className="modal-body">
              {/* Блок поиска */}
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row g-2 align-items-end access-objects-modal-filters">
                    <div className="col-md-3">
                      <label className="form-label">ФИО</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={modalFilters.name}
                        onChange={(e) =>
                          this.setState({
                            modalFilters: { ...modalFilters, name: e.target.value },
                          })
                        }
                        placeholder="Введите ФИО..."
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Должность</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={modalFilters.position}
                        onChange={(e) =>
                          this.setState({
                            modalFilters: { ...modalFilters, position: e.target.value },
                          })
                        }
                        placeholder="Введите должность..."
                      />
                    </div>
                    <div className="col-md-12 mt-2">
                      <button className="btn btn-primary btn-sm me-2" onClick={this.handleModalSearch}>
                        Найти
                      </button>
                      <button className="btn btn-secondary btn-sm" onClick={() => this.handleSelectAllFound(isCancelSelected)}>
                        {isCancelSelected ? 'Отменить выбор' : 'Выбрать все найденные'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Таблица объектов доступа */}
              <div className="table-responsive">
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th>ФИО</th>
                      <th>Должность</th>
                      <th>Пройден мед. осмотр</th>
                      <th>В черном списке</th>
                      <th style={{ width: '40px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalAccessObjects.map((ao) => (
                      <tr key={ao.id} className={ao.already_added ? 'table-secondary' : ''}>
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={
                              modalSelectedIds.has(ao.id)
                              || ao.already_added
                              || this.state.isModalSelectedAll && !this.state.modalExcludedIds.has(ao.id)
                            }
                            onChange={() => this.handleToggleAccessObject(ao.id, ao.already_added)}
                          />
                        </td>
                        <td><Link to={`/access_objects/${ao.id}/`} target="_blank">{ao.name}</Link></td>
                        <td>{ao.position}</td>
                        <td>{ao.medical_exam}</td>
                        <td>
                          {ao.blacklist ? (
                            <span
                              role="button"
                              tabIndex={0}
                              style={{ cursor: 'pointer', textDecoration: 'underline', color: '#ff5a00'}}
                              onClick={() => this.openBlacklistHistoryForAo(ao.id)}
                              onKeyDown={(e) => e.key === 'Enter' && this.openBlacklistHistoryForAo(ao.id)}
                            >
                              Да
                            </span>
                          ) : (
                            'Нет'
                          )}
                        </td>
                        <td>
                          <span
                            className="tooltip-link"
                            onMouseEnter={(e) => this.showTooltip(e, ao)}
                            onMouseLeave={this.hideTooltip}
                          >
                            <i className="ti ti-info-circle"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Пагинация */}
              {modalTotalPages > 1 && (
                <nav className="mt-3">
                  <ul className="pagination pagination-sm justify-content-center">
                    <li className={`page-item ${modalPage === 1 ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalPage > 1) this.loadModalAccessObjects(modalPage - 1)
                        }}
                      >
                        Назад
                      </a>
                    </li>
                    {[...Array(modalTotalPages)].map((_, idx) => (
                      <li key={idx} className={`page-item ${modalPage === idx + 1 ? 'active' : ''}`}>
                        <a
                          className="page-link"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            this.loadModalAccessObjects(idx + 1)
                          }}
                        >
                          {idx + 1}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${modalPage === modalTotalPages ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalPage < modalTotalPages) this.loadModalAccessObjects(modalPage + 1)
                        }}
                      >
                        Вперед
                      </a>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeAccessObjectsModal}>
                Отмена
              </button>
              <button type="button" className="btn btn-primary" onClick={this.handleApplyAccessObjects}>
                Применить
              </button>
            </div>
          </div>
        </div>

        {/* Тултип с информацией об объекте доступа */}
        <AccessObjectTooltip data={this.state.tooltipData} position={this.state.tooltipPosition} />
        {this.renderBlacklistHistoryModalForOG()}
      </div>
    )
  }

  // Дополнительный контент в группу формы
  renderFormGroupInclude(item, position) {
    const tabTitle = item[0]

    // Блок «посетители» только у уже созданной карточки (не на форме создания)
    if (tabTitle === 'Основное' && position === 'bottom') {
      const objectId = this.object_id
      if (!objectId || objectId === 0 || objectId === 'new') return null
      return this.renderAccessObjectsTable()
    }

    return null
  }

  renderModals() {
    const modals = super.renderModals ? super.renderModals() : []
    return [...modals, this.renderAccessObjectsModal()]
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
